"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRunUploadDir = exports.getRunUploadBaseDir = exports.trimAndRemoveTrailingSlash = void 0;
const trimAndRemoveTrailingSlash = (value) => {
    if (!value)
        return "";
    return value.trim().replace(/\/+$/, "");
};
exports.trimAndRemoveTrailingSlash = trimAndRemoveTrailingSlash;
const getRunUploadBaseDir = ({ workDirectory, publishDir, launchDirectory, isCloudJob, }) => (0, exports.trimAndRemoveTrailingSlash)(workDirectory) ||
    (0, exports.trimAndRemoveTrailingSlash)(isCloudJob ? publishDir : launchDirectory);
exports.getRunUploadBaseDir = getRunUploadBaseDir;
const getRunUploadDir = (params) => {
    const baseDir = (0, exports.getRunUploadBaseDir)(params);
    return baseDir ? `${baseDir}/foundryUploads/run${params.runId}` : "";
};
exports.getRunUploadDir = getRunUploadDir;
